/* import __COLOCATED_TEMPLATE__ from './upgrade-diy.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import PRICING_TABLE_DATA from "../../constants/pricing-plans";

/**
 * This is the upgrade CTA for a DIY user to move to a sub based model
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-upgrade-diy', 'margin-top-32px'],

  /**
   * Register services
   */
  companyCommandService : service('commands/company-commands'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  onContactSupportConfirmed: () => {},

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}      True when we are sending the contact us request to the db.
   */
  _isSendingContactRequest: false,

  actions: {
    /**
     *
     */
    onContactUsClicked() {
      this.set('_isSendingContactRequest', true);

      this.companyCommandService.requestUpgrade(1, PRICING_TABLE_DATA.UPGRADE_REQUEST_PRICING).then(() => {
        this.onContactSupportConfirmed();
      }).catch(() => {
        this.set('_isSendingContactRequest', false)
      });
    }
  }
});
